var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 24,
    height: 24,
    rx: 12,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 24,
    height: 24,
    rx: 12,
    stroke: "#949494"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9987 11.9997C12.082 11.9997 11.2973 11.6733 10.6445 11.0205C9.99175 10.3677 9.66536 9.58301 9.66536 8.66634C9.66536 7.74967 9.99175 6.96495 10.6445 6.31217C11.2973 5.6594 12.082 5.33301 12.9987 5.33301C13.9154 5.33301 14.7001 5.6594 15.3529 6.31217C16.0056 6.96495 16.332 7.74967 16.332 8.66634C16.332 9.58301 16.0056 10.3677 15.3529 11.0205C14.7001 11.6733 13.9154 11.9997 12.9987 11.9997ZM6.33203 18.6663V16.333C6.33203 15.8608 6.4537 15.4269 6.69703 15.0313C6.94036 14.6358 7.26314 14.3336 7.66536 14.1247C8.52648 13.6941 9.40148 13.3713 10.2904 13.1563C11.1793 12.9413 12.082 12.8336 12.9987 12.833C13.9154 12.8325 14.8181 12.9402 15.707 13.1563C16.5959 13.3725 17.4709 13.6952 18.332 14.1247C18.7348 14.333 19.0579 14.6352 19.3012 15.0313C19.5445 15.4275 19.6659 15.8613 19.6654 16.333V18.6663H6.33203Z",
    fill: "#949494"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIcon);
export default __webpack_public_path__ + "static/media/profile-icon.b82a48e9c5bdc18e8707a08cf96ff40c.svg";
export { ForwardRef as ReactComponent };